<template>
  <DataList
    title="Клієнти"
    resource="clients"
    :columns="columns"
    :filter="filter"
    :get-items-fn="getClients"
    :search-label="'Пошук за назвою клієнта'"
  >
    <template v-slot:action-buttons>
      <DownloadFile
        :location="`clients/rpc/export-to-excel?${filterParams}`"
        filename="Клієнти"
        extension="xlsx"
        tooltip="Завантажити у форматі Excel"
      />
    </template>
    <template v-slot:filters>
      <v-row no-gutters>
        <v-col md="6" sm="12">
          <ManagerSelect v-model="manager" label="Менеджер" class="ma-1" />
        </v-col>
        <v-col md="6" sm="12">
          <EmployeeSelect v-model="analyst" label="Аналітик" class="ma-1" />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col md="6" sm="12">
          <ProductSelect v-model="product" label="Продукт" class="ma-1" />
        </v-col>
        <v-col md="6" sm="12">
          <ServiceSelect v-model="service" label="Сервіс" class="ma-1" />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import ManagerSelect from "../managers/ManagerSelect.vue";
import EmployeeSelect from "../employees/EmployeeSelect.vue";
import DownloadFile from "../../../components/DowloadFile.vue";
import ProductSelect from "../products/ProductSelect.vue";
import ServiceSelect from "../services/ServiceSelect.vue";
import * as clientsApi from "../../../backend/clientsApi.js";
import * as managerApi from "../../../backend/managersApi.js";
import * as employeeApi from "../../../backend/employeesApi.js";
import * as productsApi from "../../../backend/productsApi.js";
import * as servicesApi from "../../../backend/servicesApi.js";

export default {
  components: {
    ManagerSelect,
    EmployeeSelect,
    DownloadFile,
    ProductSelect,
    ServiceSelect,
  },
  data: () => ({
    columns: [
      { title: "id", name: "id", width: 65, sortable: true, isDesc: null },
      {
        title: "Найменування",
        name: "title",
        rowType: "wide",
        sortable: true,
        isDesc: null,
      },
      {
        title: "Менеджер",
        name: "manager",
        dataPath: "manager.title",
        rowType: "wide",
      },
      {
        title: "Аналітик",
        name: "analyst",
        dataPath: "analyst.title",
        rowType: "wide",
      },
      {
        title: "Проекти",
        name: "projectsText",
        rowType: "wide",
      },
      {
        title: "Співпрацю призупинено",
        name: "partnershipStopped",
        type: "bool",
      },
    ],
    manager: null,
    analyst: null,
    product: null,
    service: null,
  }),
  computed: {
    filter() {
      return {
        manager: {
          id: this.manager ? this.manager.id : "",
          title: this.manager ? this.manager.title : "",
        },
        analyst: {
          id: this.analyst ? this.analyst.id : "",
          title: this.analyst ? this.analyst.title : "",
        },
        product: {
          id: this.product ? this.product.id : "",
          title: this.product ? this.product.title : "",
        },
        service: {
          id: this.service ? this.service.id : "",
          title: this.service ? this.service.title : "",
        },
      };
    },
    filterParams() {
      return `filter.managerId=${this.filter?.manager?.id ?? ""}
              &filter.analystId=${this.filter?.analyst?.id ?? ""}
              &filter.productId=${this.filter?.product?.id ?? ""}
              &filter.serviceId=${this.filter?.service?.id ?? ""}`;
    },
  },
  created() {
    this.getManager();
    this.getAnalyst();
  },
  methods: {
    getClients(...args) {
      return clientsApi.getClients(args[0], args[1], args[2], args[3], args[4]);
    },
    async getManager() {
      const managerId = this.$router.currentRoute.query.managerId;
      if (!managerId) {
        return;
      }
      const result = await managerApi.getManager(managerId);
      this.manager = {
        id: result.id,
        title: result.title,
      };
    },
    async getAnalyst() {
      const analystId = this.$router.currentRoute.query.analystId;
      if (!analystId) {
        return;
      }
      const result = await employeeApi.getEmployee(analystId);
      this.analyst = {
        id: result.id,
        title: result.title,
      };
    },
    async getProduct() {
      const productId = this.$router.currentRoute.query.productId;
      if (!productId) {
        return;
      }
      const result = await productsApi.getProduct(productId);
      this.product = {
        id: result.id,
        title: result.title,
      };
    },
    async getService() {
      const serviceId = this.$router.currentRoute.query.serviceId;
      if (!serviceId) {
        return;
      }
      const result = await servicesApi.getService(serviceId);
      this.service = {
        id: result.id,
        title: result.title,
      };
    },
  },
};
</script>
